import { useEffect, useState } from 'react';

export default function Hero() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/6dbfd1ddec2d731a08867e574bf6feaf.jpg)'
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      
      <div className={`relative z-10 w-full max-w-6xl mx-auto px-6 text-center transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
        
        <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
          <span className="text-orange-500">SUNIL ELECTRONICS</span> Repair Shop in Sikandrabad
        </h1>
        
        <p className="text-2xl md:text-3xl text-white/95 mb-8 font-medium">
          20+ saal ka anubhav | Local & honest technician
        </p>
        
        <p className="text-lg md:text-xl text-white/90 mb-12 max-w-3xl mx-auto">
          Sunil Saini ke saath apne electronics ko theek karwayen. Har repair se pehle proper testing aur reasonable charges.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a 
            href="tel:9927256718"
            className="group px-8 py-4 bg-orange-500 hover:bg-orange-600 text-white font-semibold rounded-lg transition-all duration-300 flex items-center gap-3 whitespace-nowrap cursor-pointer shadow-lg hover:shadow-xl transform hover:scale-105"
          >
            <i className="ri-phone-fill text-xl"></i>
            <span>Call Now: 9927256718</span>
          </a>
          
          <a 
            href="https://wa.me/919927256718"
            target="_blank"
            rel="noopener noreferrer"
            className="group px-8 py-4 bg-green-500 hover:bg-green-600 text-white font-semibold rounded-lg transition-all duration-300 flex items-center gap-3 whitespace-nowrap cursor-pointer shadow-lg hover:shadow-xl transform hover:scale-105"
          >
            <i className="ri-whatsapp-fill text-xl"></i>
            <span>WhatsApp Us</span>
          </a>
        </div>
        
        <div className="mt-12 text-white/90 text-base">
          <p className="flex items-center justify-center gap-2">
            <i className="ri-time-line text-xl"></i>
            <span>Daily 10:00 AM – 10:00 PM</span>
          </p>
        </div>
      </div>
      
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}
